import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

type UpdateMaterialResponse = ClientInferResponseBody<
  typeof contract.quoteRequestLines.updateMaterial,
  200
>;

type UpdateMaterialPayload = ClientInferRequest<
  typeof contract.quoteRequestLines.updateMaterial
>["body"];

export const updateMaterial = async ({
  quoteRequestLineId,
  payload,
}: {
  quoteRequestLineId: string;
  payload: UpdateMaterialPayload;
}): Promise<UpdateMaterialResponse | null> => {
  if (!quoteRequestLineId) {
    return null;
  }

  const response = await api.quoteRequestLines.updateMaterial.mutation({
    body: {
      ...payload,
    },
    params: {
      id: quoteRequestLineId,
    },
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError(
    "Une erreur est survenue lors de la mise à jour de la matière",
    response.status,
    response.body,
  );
};
